import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {uploadFile, uploadFileS3 } from '../../Services/file_service';

const initialState = {
    file: ''
}



export const fileSlice = createSlice({
    name: 'file',
    initialState,
    reducers: {
        setFile: (state, action) => {
            state.file = action.payload;
        },
    }
});

export const UploadFile = createAsyncThunk(
    'file/uploadFile',
    async (data, { dispatch }) => {
        const fileRes = await uploadFile(data);
        dispatch(setFile(fileRes));
        return fileRes;
    }
);

export const UploadFileS3 = createAsyncThunk(
    'file/uploadFileS3',
    async (data, { dispatch }) => {
        const fileRes = await uploadFileS3(data);
        dispatch(setFile(fileRes));
        return fileRes;
    }
);

export const { setFile } = fileSlice.actions;
export default fileSlice.reducer;